import NavigationUtils from '../../../utils/navigation.utils';
import {
  CardStatusMessage,
  CardValidStatus,
  CreditStatusMessage,
  CreditValidStatus,
} from './CardMessageConfig';
import CardMessage from './CardMessage';
import {
  ShowCreditsMessages,
  ShowAutomaticCreditsMessages,
} from '../CreditCard/CreditConfig';
import CreditStatus from '../../../constants/credit.status';

export default function CardMessagesList({
  status,
  cardUid,
  cardNumber,
  credit = null,
  size = CardMessage.Size.LARGE,
  className = '',
  lendingButtonEnabled = false,
  isPersonalizedCard = false,
  automaticLendingEnabled = false,
}) {
  const mustShowLendingMessages =
    (lendingButtonEnabled && !automaticLendingEnabled) ||
    (lendingButtonEnabled &&
      automaticLendingEnabled &&
      ShowAutomaticCreditsMessages.includes(credit?.status)) ||
    (!lendingButtonEnabled && !ShowCreditsMessages.includes(credit?.status));

  const navigate = (path, type) => {
    NavigationUtils.navigate(path, false, {
      source: NavigationUtils.Sources.WALLET,
      cardUid: cardUid,
      cardNumber: cardNumber,
      type: type,
    });
  };

  const messages = [];

  if (CardValidStatus.includes(status)) {
    messages.push(
      <CardStatusMessage
        status={status}
        navigate={path => navigate(path, 'debit')}
        className={className}
        size={size}
        cardUid={cardUid}
        isPersonalizedCard={isPersonalizedCard}
        automaticLendingEnabled={automaticLendingEnabled}
      />,
    );
  }

  const isValidCreditStatus =
    credit != null && CreditValidStatus.includes(credit?.status);

  if (mustShowLendingMessages && isValidCreditStatus) {
    messages.push(
      <CreditStatusMessage
        status={credit?.status}
        navigate={path => navigate(path, 'credit')}
        className={className}
        size={size}
        availableAmount={credit?.availableAmount}
        payment={credit?.payment}
        automaticLendingEnabled={automaticLendingEnabled}
      />,
    );
  }
  return messages;
}
